import React from "react";
import { View, Text } from "@react-pdf/renderer";
import Styles from "../Styles";

const BankFieldRow = ({ styles, label, lines = 1 }) => (
  <View
    style={{
      width: "100%",
      flexDirection: "row",
      alignItems: "flex-start",
      marginBottom: lines > 1 ? 10 : 3,
    }}
  >
    <Text
      style={{
        ...styles.ButtonTextSmall,
        width: 88,
        flexShrink: 0,
        marginRight: 6,
      }}
      wrap={false}
    >
      {label}
    </Text>
    <View style={{ flex: 1 }}>
      {Array.from({ length: lines }).map((_, index) => (
        <View
          key={index}
          style={{
            ...styles.line,
            flexGrow: 0,
            height: 16,
            marginTop: index === 0 ? 0 : 5,
          }}
        />
      ))}
    </View>
  </View>
);

const BankColumn = ({ styles }) => (
  <View
    style={{
      width: "48%",
      flexDirection: "column",
      // gap: 6,
    }}
  >
    <BankFieldRow styles={styles} label="Bank Name" />
    <BankFieldRow styles={styles} label="Address" lines={1} />
    <BankFieldRow styles={styles} label="" lines={1} />
    <BankFieldRow styles={styles} label="Tel No." />
    <BankFieldRow styles={styles} label="Account No." />
  </View>
);

const BankAccounts = ({ primaryColor = "081e56" }) => {
  const styles = Styles(primaryColor);

  return (
    <View style={{ ...styles.FlexStartColumn, gap: 0 }}>
      <View
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 4,
          width: "100%",
        }}
      >
        <Text style={{ ...styles.ContentSemiBold, width: "70%" }}>
          Bank Accounts (Held at)
        </Text>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <Text
            style={{ ...styles.ButtonTextSmall, fontSize: 10, marginRight: 4 }}
          >
            I have
          </Text>
          <View style={styles.numberBox} />
          <Text
            style={{ ...styles.ButtonTextSmall, fontSize: 10, marginRight: 4 }}
            wrap={false}
          >
            {" "}
            (number) bank accounts
          </Text>
        </View>
      </View>
      <View style={styles.panel}>
        <View style={{ width: "100%" }}>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              marginBottom: 15,
              gap: 24,
            }}
          >
            <BankColumn styles={styles} />
            <BankColumn styles={styles} />
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              marginBottom: 15,
              gap: 24,
            }}
          >
            <BankColumn styles={styles} />
            <BankColumn styles={styles} />
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
              marginBottom: 15,
              gap: 24,
            }}
          >
            <BankColumn styles={styles} />
            <BankColumn styles={styles} />
          </View>
        </View>
      </View>
    </View>
  );
};

export default BankAccounts;
